import React from "react";
const pinIcon = "https://cdn.obsess-vr.com/fendi/sections_icon_inactive+.svg";
const selectedPinIcon = "https://cdn.obsess-vr.com/fendi/sections_icons_selected+.svg";

const FloorPin = ({ x, y, sceneName, sceneId, handleClick, isActive }) => {
    return (
        <div className='scene-selection-container flex-center' style={{ transform: `translate(${x}px, ${y}px)` }} onClick={() => handleClick(sceneId)}>
            <div className='minimap-text'>{sceneName}</div>
            <div className='minimap-circle'>
                <img src={isActive ? selectedPinIcon : pinIcon} width="20" />
            </div>
        </div>
    )
}

FloorPin.propTypes = {
    x: PropTypes.string,
    y: PropTypes.string,
    isActive: PropTypes.bool,
    sceneName: PropTypes.string,
    handleClick: PropTypes.func,
    sceneId: PropTypes.string
}

export default FloorPin;